// Border presets
export const BORDER_PRESETS = {
  none:    { top: false, bottom: false, left: false, right: false },
  outline: { top: true, bottom: true, left: true, right: true },
  inside:  { top: true, bottom: true, left: true, right: true },
  all:     { top: true, bottom: true, left: true, right: true },
};

export const BORDER_STYLES = ['solid', 'dashed', 'dotted', 'double'];
export const BORDER_WIDTHS = [1, 2, 3];

// Build a border object from a preset/style combination
export function buildBorderObj({
  preset = 'all',
  top, bottom, left, right,
  style = 'solid',
  color = '#000000',
  width = 1,
  diagTR = false,
  diagBL = false,
} = {}) {
  const p = BORDER_PRESETS[preset] || BORDER_PRESETS.all;
  const t = top !== undefined ? top : p.top;
  const b = bottom !== undefined ? bottom : p.bottom;
  const l = left !== undefined ? left : p.left;
  const r = right !== undefined ? right : p.right;

  const obj = {
    borderTop: t, borderBottom: b, borderLeft: l, borderRight: r,
    borderColor: color, borderStyle: style,
    borderTopStyle: style, borderBottomStyle: style,
    borderLeftStyle: style, borderRightStyle: style,
    borderTopColor: color, borderBottomColor: color,
    borderLeftColor: color, borderRightColor: color,
    borderTopWidth: width, borderBottomWidth: width,
    borderLeftWidth: width, borderRightWidth: width,
    diagTR, diagBL,
    diagColor: color, diagStyle: style, diagWidth: width,
  };
  return obj;
}

// Build CSS border string from cell data
export function borderCSS(cell, side) {
  const key = side.charAt(0).toUpperCase() + side.slice(1);
  const enabled = cell[`border${key}`];
  if (!enabled) return undefined;
  const w = cell[`border${key}Width`] || 1;
  const s = cell[`border${key}Style`] || 'solid';
  const c = cell[`border${key}Color`] || '#000000';
  const thickness = w >= 3 ? '3px' : w === 2 ? '2px' : '1px';
  if (s === 'double') return `3px double ${c}`;
  return `${thickness} ${s} ${c}`;
}

export function diagonalCSS(cell) {
  const parts = [];
  if (cell.diagTR) {
    const w = cell.diagWidth || 1;
    const c = cell.diagColor || '#000000';
    parts.push(`linear-gradient(to top right, transparent calc(50% - ${w/2}px), ${c} calc(50% - ${w/2}px), ${c} calc(50% + ${w/2}px), transparent calc(50% + ${w/2}px))`);
  }
  if (cell.diagBL) {
    const w = cell.diagWidth || 1;
    const c = cell.diagColor || '#000000';
    parts.push(`linear-gradient(to bottom right, transparent calc(50% - ${w/2}px), ${c} calc(50% - ${w/2}px), ${c} calc(50% + ${w/2}px), transparent calc(50% + ${w/2}px))`);
  }
  if (parts.length === 0) return undefined;
  if (parts.length === 1) return parts[0];
  return parts.join(', ');
}

// Border UI options
export const BORDER_UI = [
  { label: 'No Border',    icon: '⊞',   preset: 'none' },
  { label: 'Bottom',       icon: '⎔',   dir: 'bottom' },
  { label: 'Top',          icon: '⎔',   dir: 'top' },
  { label: 'Left',         icon: '⎔',   dir: 'left' },
  { label: 'Right',        icon: '⎔',   dir: 'right' },
  { label: 'All Borders',  icon: '⊟',   preset: 'all' },
  { label: 'Outside',      icon: '⊡',   preset: 'outline' },
  { label: 'Inside',       icon: '⧠',   preset: 'inside' },
  { label: 'Thick Box',    icon: '▣',   preset: 'all', width: 3 },
  { label: 'Thick Bottom', icon: '▄',   dir: 'bottom', width: 3 },
  { label: 'Double Bottom',icon: '▌',   dir: 'bottom', style: 'double' },
  { label: 'Diagonal \\',  icon: '⤡',  diag: 'TR' },
  { label: 'Diagonal /',   icon: '⤢',  diag: 'BL' },
];
